<template>
  <div class="switch-components">
    <ul class="component-list">
      <template v-for="(item, index) in componentList">
        <li
          :key="index"
          v-if="!item.hidden"
          class="component-item-wrap"
          :class="{
            'active-item-wrap':
              activeComponent === item.component ||
              (item.children && item.children.includes(activeComponent))
          }"
          @click="handleChange(item.component)"
        >
          <div class="component-item">{{ $t(item.title) }}</div>
        </li>
      </template>
    </ul>
    <div class="handles-wrap">
      <slot name="handles"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    componentList: {
      type: Array,
      required: true
    },
    activeComponent: {
      type: String
    }
  },

  methods: {
    handleChange(activeComponent) {
      this.$emit('change-component', activeComponent)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../style/variable.less';

.switch-components {
  height: @switchComponentsHeight;
  background-color: @backColor;
  border-bottom: 1px solid @lineColor;
  .component-list {
    float: left;
    display: flex;
    height: 100%;
    .component-item-wrap {
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;
      transition: 0.3s;
      &::after {
        content: '';
        width: 40px;
        height: 2px;
        position: absolute;
        bottom: -1px;
        left: 50%;
        transform: translateX(-20px);
        background-color: @themeColor;
        opacity: 0;
        transition: 0.3s;
      }
      .component-item {
        padding: 0 40px;
        font-size: 14px;
        line-height: 20px;
        border-right: 1px solid @lineColor;
      }
      &:last-of-type .component-item {
        border: 0;
      }
    }
    .component-item-wrap:hover,
    .active-item-wrap {
      color: @themeColor;
      &::after {
        opacity: 1;
      }
    }
  }
  .handles-wrap {
    float: right;
    height: 100%;
    padding-right: 20px;
    display: flex;
    align-items: center;
  }
}
</style>
